<script lang="ts">
    import { Link } from "svelte-navigator";
    import { createEventDispatcher } from "svelte";
    import { CopyIcon, TrashIcon } from "@anyways-open/common-svgs";
    import { _ } from "svelte-i18n";
    import { appManager } from "../../AppManager";
    import type { ScenarioData } from "../../api/projects/data/scenarios/ScenarioData";
    import type { ProjectDetailsData } from "../../api/projects/data/projects/ProjectDetailsData";

    export let scenario: ScenarioData;
    export let project: ProjectDetailsData;

    let url = `/scenario/${scenario.id}`;

    let canDelete: boolean = true;
    $: if (typeof project !== "undefined") {
        canDelete = true;
        for (let rr of project.reRoutes) {
            for (let rrs of rr.scenarios) {
                if (rrs.scenario.id === scenario.id) {
                    canDelete = false;
                    break;
                }
            }
        }
    }

    // TODO: for now guids are the new API, all other are the old.
    let canCopy = false;
    $: canCopy =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
            scenario.branchId
        );

    const copy = createEventDispatcher();
    function onCopy(): void {
        copy("copy");
    }

    const remove = createEventDispatcher();
    const onRemove = async () => {
        var result = await appManager.ModalHooks.ScenarioDeleteConfirmModal.open(scenario);
        if (!result) return;

        remove("remove");
    };

    scenario.name ??= "";
    if (scenario.name.length === 0) {
        scenario.name = `Scenario ${scenario.functionalName}`;
    }
    scenario.description ??= "";
    let scenarioName: string = scenario.name;
    let scenarioDescription: string = scenario.description;
    let scenarioId = scenario.id;

    $: if (typeof scenario !== "undefined" &&
        scenarioId !== scenario.id
    ) {
        scenarioName = scenario.name;
        scenarioDescription = scenario.description;
    }

    async function updateScenario() {
        if (
            typeof scenario !== "undefined" &&
            (scenario.name !== scenarioName ||
                scenario.description !== scenarioDescription)
        ) {
            scenario.name = scenarioName;
            scenario.description = scenarioDescription;

            await appManager.api.projects.updateScenario({
                accessToken:
                    await appManager.api.getAccessToken(),
                id: scenario.id,
                scenarioData: scenario,
            });
        }
    }

    let canOpenProject = true;
    appManager.getCanOpenProjects().subscribe((id) => {
        canOpenProject = id;
    })
</script>

<div class="list-group-item">
    <div class="row align-items-center">
        <div class="col-1 me-auto">
            {#if canOpenProject}
                <Link to={url}
                    ><button
                        title={scenarioName}
                        class="btn btn-small badge badge-hover badge-scenario"
                        >{scenario.functionalName}</button
                    ></Link>
            {:else}
                <button
                    disabled
                    title={scenarioName}
                    class="btn btn-small badge badge-hover badge-scenario"
                    >{scenario.functionalName}</button>
            {/if}
        </div>
        <div class="col-8">
            <div
                class="mb-0"
                on:focusout={async () => await updateScenario()}
                contenteditable="true"
                bind:innerHTML={scenarioName} />

            <div
                class="d-block small text-truncate text-gray-700"
                on:focusout={async () => await updateScenario()}
                contenteditable="true"
                bind:innerHTML={scenarioDescription} />
        </div>
        <div class="col-auto ms-auto">
            <div>
                <button
                    class="btn icon icon-xs text-dark d-inline p-0 {canCopy
                        ? ''
                        : 'disabled'}"
                    title="Copy"
                    on:click={onCopy}>
                    <CopyIcon />
                </button>

                {#if !canDelete}
                    <span title={$_("impact.project.cannotDelete")}>
                        <button
                            class="btn icon icon-xs text-dark d-inline p-0 disabled"
                            on:click={onRemove}>
                            <TrashIcon />
                        </button>
                    </span>
                {:else}
                    <button
                        class="btn icon icon-xs text-dark d-inline p-0"
                        title={$_("impact.project.deleteScenario")}
                        on:click={onRemove}>
                        <TrashIcon />
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .row {
        border-bottom: rgb(226, 226, 226) 1px solid;
    }
    .row:last-child {
        border-bottom: none;
    }

    [contenteditable] {
        border: 1px solid rgba(170, 170, 170, 0);
        border-radius: 4px;
        min-width: 25%;
    }

    [contenteditable]:hover {
        border: 1px solid #eee;
    }

    .badge-scenario {
        background-color: #ffc926;
        color: #000;
        height: 20px;
        margin: 2px;
    }

    .badge-hover:hover {
        box-shadow: 1px 1px 5px gray;
    }

    .btn.disabled.icon {
        opacity: 0.2;
    }
</style>
